import styled from 'styled-components';

export const StyledPaintContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
